import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Row, Spinner } from "reactstrap"
import API from "../../apis"
import ISGGB from "../../assets/images/ismsf.png"
import tunisie_rep from "../../assets/images/tn_rep.png"

const DetailEmploiEnseignant = props => {
  let enseignant_id = null
  let annee_id = null

  if (localStorage.getItem("userAuthEnseignant")) {
    const userAuthEnseignant = JSON.parse(
      localStorage.getItem("userAuthEnseignant")
    )

    enseignant_id = userAuthEnseignant.user.enseignant_id
    annee_id = userAuthEnseignant.user.annee_id
  }

  const [loading, setLoading] = useState(false)
  const [quarts, setQuarts] = useState([])
  const [jours, setJours] = useState([])

  const [pdfUrl, setPdfUrl] = useState(null)

  const anneeScolaire = JSON.parse(localStorage.getItem("anneeScolaire"))

  const annee = anneeScolaire?.label

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(false)

        /*
        |--------------------------------------------------------------------------
        | Charger les données emploi
        |--------------------------------------------------------------------------
        */

        const resE = await API.post("emploi/get_by_id", {
          enseignant_id: enseignant_id,
          semestre_id: props.semestre_value,
          annee_id: annee_id,
        })

        setQuarts(resE.data.emploi[0].quarts)
        setJours(resE.data.emploi[0].jours)

        /*
        |--------------------------------------------------------------------------
        | Charger PDF depuis API
        |--------------------------------------------------------------------------
        */

        const responsePdf = await API.post(
          "enseignant/get_emploi_enseignant_pdf",
          {
            annee_id: annee_id,
            semestre_id: props.semestre_value,
            enseignant_id: enseignant_id,
          },
          {
            responseType: "blob",
          }
        )

        /*
        |--------------------------------------------------------------------------
        | Convertir réponse en Blob PDF
        |--------------------------------------------------------------------------
        */

        const blob = new Blob([responsePdf.data], {
          type: "application/pdf",
        })

        /*
        |--------------------------------------------------------------------------
        | Créer URL pour iframe
        |--------------------------------------------------------------------------
        */

        const url = URL.createObjectURL(blob)

        setPdfUrl(url)

        setLoading(true)
      } catch (error) {
        console.error("Erreur chargement emploi/PDF :", error)
      }
    }

    if (enseignant_id && annee_id && props.semestre_value) {
      loadData()
    }
  }, [props.semestre_value])

  /*
  |--------------------------------------------------------------------------
  | Nettoyage de l'URL Blob
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl)
      }
    }
  }, [pdfUrl])

  return (
    <React.Fragment>
      {loading ? (
        <Row>
          <div className="container">
            <div
              className="row"
              style={{
                paddingTop: "30px",
              }}
            >
              <div
                className="col"
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                République Tunisienne
                <div
                  className="col"
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  {"Ministère de l'enseignement supérieur,"}
                </div>
                <div
                  className="col"
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  de la Recherche Scientifique
                </div>
                <div
                  className="col"
                  style={{
                    marginLeft: 0,
                    fontSize: "12px",
                    textAlign: "center",
                    fontWeight: "bold",
                    paddingTop: "10px",
                  }}
                >
                  Université de Sfax
                </div>
                <div
                  className="col"
                  style={{
                    marginLeft: 0,
                    fontSize: "12px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {"Institut Supérieur de Musique de Sfax"}
                </div>
              </div>

              <div
                className="col"
                style={{
                  position: "relative",
                  textAlign: "center",
                }}
              >
                <img
                  alt="ISMSF"
                  style={{
                    width: "70%",
                  }}
                  src={ISGGB}
                />
              </div>

              <div
                className="col"
                style={{
                  position: "relative",
                  textAlign: "center",
                }}
              >
                <img
                  alt="Tunisie"
                  style={{
                    width: "28%",
                  }}
                  src={tunisie_rep}
                />
              </div>

              <div
                className="col"
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                الجمهورية التونسية
                <div
                  className="col"
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  وزارة التعليم العالي والبحث العلمي
                </div>
                <div
                  className="col"
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                    fontWeight: "bold",
                    paddingTop: "10px",
                  }}
                >
                  جامعة ﺻﻔﺎﻗﺲ
                </div>
                <div
                  className="col"
                  style={{
                    textAlign: "center",
                    marginRight: 0,
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  {"اﻟﻤﻌﻬﺪ اﻟﻌﺎﻟﻲ ﻟﻠﻤﻮﺳﻴﻘﻰ ﺑﺼﻔﺎﻗﺲ "}
                </div>
              </div>
            </div>

            <hr
              style={{
                width: "100%",
                marginTop: "0.1%",
                color: "black",
              }}
            />
          </div>

          {/*
          |--------------------------------------------------------------------------
          | IFRAME PDF
          |--------------------------------------------------------------------------
          */}

          <div
            style={{
              width: "100%",
              padding: "0px 15px",
            }}
          >
            {pdfUrl && (
              <iframe
                src={pdfUrl}
                title="Emploi enseignant"
                width="100%"
                height="900px"
                style={{
                  border: "1px solid #ddd",
                }}
              />
            )}
          </div>
        </Row>
      ) : (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Spinner type="grow" className="ms-6" color="primary" />
          </div>

          <h4
            style={{
              textAlign: "center",
              marginTop: "2%",
            }}
            className="ms-6"
          >
            Chargement ...
          </h4>
        </div>
      )}
    </React.Fragment>
  )
}

export default DetailEmploiEnseignant

DetailEmploiEnseignant.propTypes = {
  history: PropTypes.object,

  semestre_value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  semestre_label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
